import { jsx as _jsx } from "react/jsx-runtime";
import * as rq from "react-query";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { RenderWithReactHookForm } from "../jestHelpers";
export const withQueryDecorator = (Story) => {
    const queryClient = new rq.QueryClient();
    return (_jsx(rq.QueryClientProvider, { client: queryClient, children: _jsx(Story, {}) }));
};
export const withReactRouterHistoryDecorator = (Story) => {
    const history = createBrowserHistory();
    return (_jsx(Router, { history: history, children: _jsx(Story, {}) }));
};
export const withReactHookFormsDecorator = (initData) => (Story) => {
    return (_jsx(RenderWithReactHookForm, { values: initData, children: _jsx(Story, {}) }));
};
export const withDarkModeDecorator = (Story) => (_jsx("div", { className: "page--dark", children: _jsx(Story, {}) }));
//# sourceMappingURL=decorators.js.map